import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Users, FileCheck, PawPrint, Layers, ShoppingCart, IndianRupee, AlertCircle, Sparkles, TrendingUp } from "lucide-react";

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/dashboard/stats").then((r) => setS(r.data)); }, []);

  const cards = [
    { icon: Users, label: "Customers", value: s?.total_customers ?? 0,
      gradient: "linear-gradient(135deg, #D71921 0%, #B0151E 100%)", testid: "stat-customers" },
    { icon: FileCheck, label: "Pending KYC", value: s?.pending_kyc ?? 0,
      gradient: "linear-gradient(135deg, #B8862A 0%, #8E6517 100%)", alert: (s?.pending_kyc || 0) > 0, testid: "stat-pending-kyc" },
    { icon: PawPrint, label: "Animals", value: s?.total_animals ?? 0,
      gradient: "linear-gradient(135deg, #3F6B3F 0%, #2A4A2A 100%)", testid: "stat-animals" },
    { icon: Layers, label: "Total Lots", value: s?.total_lots ?? 0,
      gradient: "linear-gradient(135deg, #1F1816 0%, #3A2925 100%)", testid: "stat-total-lots" },
    { icon: Layers, label: "Available Lots", value: s?.available_lots ?? 0,
      gradient: "linear-gradient(135deg, #3F6B3F 0%, #5A8B5A 100%)", testid: "stat-available-lots" },
    { icon: ShoppingCart, label: "Sold Lots", value: s?.sold_lots ?? 0,
      gradient: "linear-gradient(135deg, #B8862A 0%, #D9A84A 100%)", testid: "stat-sold-lots" },
    { icon: AlertCircle, label: "Pending Sales", value: s?.pending_sales ?? 0,
      gradient: "linear-gradient(135deg, #D71921 0%, #7A1010 100%)", alert: (s?.pending_sales || 0) > 0, testid: "stat-pending-sales" },
    { icon: IndianRupee, label: "Total Revenue", value: `₹${(s?.total_revenue || 0).toLocaleString()}`,
      gradient: "linear-gradient(135deg, #1F1816 0%, #7A1010 60%, #D71921 100%)", testid: "stat-revenue" },
  ];

  return (
    <div>
      {/* Hero banner */}
      <div className="relative overflow-hidden rounded-3xl mb-8 p-8 md:p-10 text-white"
        style={{ background: "linear-gradient(135deg, #1F1816 0%, #7A1010 50%, #D71921 100%)" }}>
        <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#F2C97A]/20 blur-3xl" />
        <div className="absolute -bottom-32 -left-16 w-72 h-72 rounded-full bg-[#3F6B3F]/20 blur-3xl" />
        <div className="relative">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 backdrop-blur border border-white/20 text-xs font-bold uppercase tracking-widest mb-4">
            <Sparkles className="w-3 h-3 text-[#F2C97A]" /> Admin Console
          </div>
          <h1 className="font-display text-3xl md:text-5xl tracking-tight">Operations dashboard</h1>
          <p className="text-white/80 mt-2 max-w-xl">Approvals, livestock and lots — everything at a glance.</p>
          <div className="mt-5 inline-flex items-center gap-2 text-xs text-white/70">
            <TrendingUp className="w-3.5 h-3.5 text-[#F2C97A]" />
            Live data &middot; updates in real time
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map((c, i) => (
          <div key={c.label}
            className={`rounded-2xl p-5 animate-in delay-${(i % 4) + 1} relative overflow-hidden text-white ${c.alert ? "ring-2 ring-[#F2C97A]" : ""}`}
            style={{ background: c.gradient }}
            data-testid={c.testid}>
            <div className="absolute -right-6 -top-6 w-24 h-24 rounded-full bg-white/10 blur-xl" />
            <c.icon className="w-5 h-5 relative" />
            <div className="text-xs uppercase tracking-wider opacity-80 mt-3 relative">{c.label}</div>
            <div className="font-display text-2xl mt-1 relative">{c.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
